import { FormikProps } from "formik";
import { DisplayItem } from "../../../../../formcontrols/DisplayItem";
import { TextInputFormik } from "../../../../../formcontrols/InputItem";
import { FirmaDto } from "../../../../../../interfaces/schema";
import { FirmaFields } from "./StamoplysningerTop";

const FirmaStamKontakt = ({
  firma,
  editMode,
  formik,
}: {
  firma: FirmaDto;
  editMode: boolean;
  formik: FormikProps<FirmaFields>;
}) => {
  const { values } = formik;
  return (
    <div className="c-card c-item-list">
      <h4 className="flex-100">Kontaktoplysninger</h4>
      {editMode && (
        <div className="flex-100">
          <TextInputFormik
            config={{
              component: "textinput",
              id: "tlf",
              initialValue: values.tlf ?? "",
              label: "Telefon",
            }}
            formik={formik}
          />
        </div>
      )}
      {!editMode && (
        <div className="flex-100">
          <DisplayItem
            label="Telefon"
            text={firma.tlf ?? ""}
            isEditable={true}
          />
        </div>
      )}
      {editMode && (
        <div>
          <TextInputFormik
            config={{
              component: "textinput",
              id: "email",
              initialValue: values.email ?? "",
              label: "E-mail",
            }}
            formik={formik}
          />
        </div>
      )}
      {!editMode && (
        <div>
          <DisplayItem label="E-mail" text={firma.email} isEditable={true} />
        </div>
      )}
      {editMode && (
        <div className="flex-100">
          <TextInputFormik
            config={{
              component: "textinput",
              id: "emailSikker",
              initialValue: values.emailSikker ?? "",
              label: "E-mail, Domstolsstyrelsen-notifikation",
            }}
            formik={formik}
          />
        </div>
      )}
      {!editMode && (
        <div className="flex-100">
          <DisplayItem
            label="E-mail, Domstolsstyrelsen-notifikation"
            text={firma.emailSikker}
            isEditable={true}
          />
        </div>
      )}
      {editMode && (
        <div>
          <TextInputFormik
            config={{
              component: "textinput",
              id: "webAdresse",
              initialValue: values.webAdresse ?? "",
              label: "Hjemmeside",
            }}
            formik={formik}
          />
        </div>
      )}
      {!editMode && (
        <div>
          <DisplayItem
            label="Hjemmeside"
            text={firma.webAdresse}
            isEditable={true}
          />
        </div>
      )}
    </div>
  );
};

export default FirmaStamKontakt;
